// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__VLABu","clinicsSelect":"TableHeading_clinicsSelect__dgvej"};